import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import AnimCardsContainer from '@/components/AnimCards';
import '../styles/animcards.css';

const StudyTours = () => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: {sourceInstanceName: {eq: "study-tours"}}) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED, height: 250, quality: 80, placeholder: BLURRED, formats: [AUTO, WEBP])
            }
          }
        }
      }
    }
  `);

  const studyTourGallery = data.allFile.edges.map(edge => ({
    imgData: edge.node.childImageSharp.gatsbyImageData,
    title: edge.node.base.split('.')[0], // Using the base name as title
    label: 'Study Tour' // You can customize this label
  }));

  return (
    <>
      <section>
        <div className="container px-4 md:px-6">
          <h2>Visit one of our Study tours showcasing local services</h2>
          <p>Study tours are a tradition of a World Conference of Women’s Shelters, where the host city has the opportunity to showcase their local services. Study tours are scheduled for the final day of the Conference.</p>
          <div className="p-8 bg-gray-200">
            <p className="mb-2"><b>Date:</b> Thursday 18 September 2025</p>
            <p className="mb-2"><b>Time:</b> TBC (departing morning from ICC Sydney)</p>
            <p className="mb-2"><b>Cost:</b> Study tours will be offered to 5WCWS delegates only, at an additional cost of AUD150 including GST per person.</p>
            <p className="mb-2"><b>Who can attend?</b> Up to 70 delegates attend and are available to 5WCWS delegates only.</p>
          </div>
        </div>
      </section>

      <section>
        <AnimCardsContainer data={studyTourGallery} title="4WCWS Study tour gallery" delta={0.5} />
      </section>
    </>
  );
};

export default StudyTours;

export function Head() {
  const { title } = useSiteMetadata();
  return (
    <>
      <title>{`Study Tours - ${title}`}</title>
      <meta name="description" content="Join the study tours at the 5th World Conference of Women's Shelters 2025. Explore women's shelters and support facilities as part of our educational tours." />
      <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, study tours, educational tours, women's support facilities, shelter visits" />
    </>
  );
}

